<template>
  <div class="notification__container--lg body-text--md" :class="getBannerProperty(bannerType, `backgroundClass`)">
    <icon
      v-if="!isDefaultBanner"
      :icon-name="getBannerProperty(bannerType, `iconName`)"
      :class="getBannerProperty(bannerType, `iconClass`)"
      viewBox="0 0 16 16"
      class="banner-icon"/>
    <slot name="text"></slot>
  </div>
</template>

<script>
  import Icon from "StyleguideComponents/Icon.vue";

  export default {
    components: {
      Icon
    },
    props: {
      bannerType: {
        type: String,
        required: true
      },
    },
    data(){
      return {
        bannerStyles: {
          "success": {
            "backgroundClass": "color--forest background--seaglass border-color--forest",
            "iconName": "check-circle",
            "iconClass": "success-icon"
          },
          "error": {
            "backgroundClass": "color--burgundy background--burgundy-light border-color--burgundy",
            "iconName": "alert-circle",
            "iconClass": "alert-circle-icon"
          },
          "warning": {
            "backgroundClass": "color--ruby background--gold-light border-color--ruby",
            "iconName": "bell",
            "iconClass": "warning-icon"
          },
          "default": {
            "backgroundClass": "color--sapphire background--sky border-color--sapphire"
          }
        }
      }
    },
    computed: {
      isDefaultBanner() {
        return this.bannerType === 'default';
      }
    },
    methods: {
      getBannerProperty(type, prop) {
        return this.bannerStyles[type][prop];
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~StyleguideAssets/scss/master.scss";
</style>